
import React, { useState, useEffect } from 'react';
import { toast } from '../../../../utils/toast';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Switch,
  FormControlLabel,
  Button,
  MenuItem,
} from '@mui/material';
import { ProveedorDto } from '../../../../services/api/proveedoresApi';
import { useMaintenanceApi } from '../../../../services/api/maintenanceApi';
import { GenericItem } from '../../../types/generic.types';
interface ProveedorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: ProveedorDto) => Promise<void>;
  title: string;
  initialData?: ProveedorDto;
  isLoading: boolean;
  isEdit?: boolean;
}

const ProveedorModal: React.FC<ProveedorModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  initialData,
  isLoading,
  isEdit = false,
}) => {
  const [formData, setFormData] = useState<ProveedorDto>({
    IdTipoDocumento: 0,
    NumeroIdentificacion: '',
    Nombre: '',
    RepresentanteLegal: '',
    Direccion: '',
    Telefono: '',
    Correo: '',
    Web: '',
    Activo: true,
  });

  const [tiposDocumento, setTiposDocumento] = useState<GenericItem[]>([]);
  const tipoDocumentoApi = useMaintenanceApi('tipos-documento');

  useEffect(() => {
    const loadTiposDocumento = async () => {
      const data = await tipoDocumentoApi.getAll();
      setTiposDocumento(data.filter(tipo => tipo.Activo));
    };
    loadTiposDocumento();
  }, []);

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData({
        IdTipoDocumento: 0,
        NumeroIdentificacion: '',
        Nombre: '',
        RepresentanteLegal: '',
        Direccion: '',
        Telefono: '',
        Correo: '',
        Web: '',
        Activo: true,
      });
    }
  }, [initialData, isOpen]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await onSubmit(formData);
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || 'Error al guardar los datos';
      toast.error('Error');
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            select
            margin="dense"
            label="Tipo de Documento"
            fullWidth
            required
            value={formData.IdTipoDocumento}
            onChange={(e) => setFormData({ ...formData, IdTipoDocumento: Number(e.target.value) })}
            sx={{ mb: 2 }}
          >
            <MenuItem value={0} disabled>Seleccione un tipo de documento</MenuItem>
            {tiposDocumento.map((tipo) => (
              <MenuItem key={tipo.Id} value={tipo.Id}>
                {tipo.Nombre}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            margin="dense"
            label="Número de Identificación"
            fullWidth
            required
            value={formData.NumeroIdentificacion}
            onChange={(e) => setFormData({ ...formData, NumeroIdentificacion: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Nombre"
            fullWidth
            required
            value={formData.Nombre}
            onChange={(e) => setFormData({ ...formData, Nombre: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Representante Legal"
            fullWidth
            required
            value={formData.RepresentanteLegal}
            onChange={(e) => setFormData({ ...formData, RepresentanteLegal: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Dirección"
            fullWidth
            required
            value={formData.Direccion}
            onChange={(e) => setFormData({ ...formData, Direccion: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Teléfono"
            fullWidth
            required
            value={formData.Telefono}
            onChange={(e) => setFormData({ ...formData, Telefono: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Correo Electrónico"
            type="email"
            fullWidth
            required
            value={formData.Correo}
            onChange={(e) => setFormData({ ...formData, Correo: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Sitio Web"
            fullWidth
            value={formData.Web || ''}
            onChange={(e) => setFormData({ ...formData, Web: e.target.value })}
            sx={{ mb: 2 }}
          />
          {!isEdit && (
            <FormControlLabel
              control={
                <Switch
                  checked={formData.Activo}
                  onChange={(e) => setFormData({ ...formData, Activo: e.target.checked })}
                />
              }
              label="Activo"
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button 
            type="submit" 
            variant="contained" 
            disabled={isLoading || formData.IdTipoDocumento === 0}
          >
            {isLoading ? 'Guardando...' : isEdit ? 'Actualizar' : 'Guardar'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ProveedorModal;
